import { useCallback, useState } from "react";

// Hook cho thanh chia dọc kéo được: trả về width hiện tại + handler onDragStart
// gắn vào thanh divider. Kéo chuột trái/phải để chỉnh độ rộng cột tree.
export function useResizableWidth(initial = 280, min = 180, max = 720) {
  const [width, setWidth] = useState(initial);

  const onDragStart = useCallback(
    (e) => {
      e.preventDefault();
      const startX = e.clientX;
      const startW = width;
      const onMove = (ev) => {
        const w = Math.min(max, Math.max(min, startW + (ev.clientX - startX)));
        setWidth(w);
      };
      const onUp = () => {
        window.removeEventListener("mousemove", onMove);
        window.removeEventListener("mouseup", onUp);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      };
      window.addEventListener("mousemove", onMove);
      window.addEventListener("mouseup", onUp);
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
    },
    [width, min, max]
  );

  return { width, onDragStart };
}

// Thanh chia dọc (border kéo được) giữa 2 cột.
export function ResizeDivider({ onDragStart }) {
  return (
    <div
      onMouseDown={onDragStart}
      title="Kéo để chỉnh độ rộng"
      style={{
        width: 6,
        flexShrink: 0,
        alignSelf: "stretch",
        cursor: "col-resize",
        background: "#d1d5db",
        borderRadius: 3,
      }}
    />
  );
}
